import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CategoriaPermissaoListarModule } from './categoria-permissao-listar/categoria-permissao-listar.module';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    { path: '', data: { breadcrumb : '' }, loadChildren: () => CategoriaPermissaoListarModule },
  ])],
  exports: [RouterModule]
})
export class CategoriaPermissaoRoutingModule { }
